import React, { useEffect, useState } from "react";
// import QrReader from "react-qr-barcode-scanner";
// import BarcodeScannerComponent from "react-qr-barcode-scanner";

import { BarcodeScanner } from "react-usb-barcode-scanner";
// import { BARCODE_SCANNED, BARCODE_SCANNING } from "react-usb-barcode-scanner";
import BarcodeReader from 'react-barcode-reader'

const Scanner = () => {
  const [qrData, setQRData] = useState("");

  // Handle QR code scan
  const handleScan = (data) => {
    if (data) {
    //   setQRData(data);
      console.log(data,'data')
    }
  };

  // Handle scan error
  const handleError = (err) => {
    console.error(err);
  };
  // const barcodeScannerMiddleware = (store) => (next) => (action) => {
  //     // processing barcode need to be here
  //     if(action.type === BARCODE_SCANNED){
  //       const barcode = action.payload.data;
  //     //   store.dispatch(YourActionOnScanned(barcode));
  //     setQRData(barcode)
  //     }
  //     if(action.type === BARCODE_SCANNING){
  //     //   store.dispatch(YourActionOnScanning());
  //     // setQRData(barcode)
  //     }
  //     return next(action);
  //   };

  useEffect(() => {
    console.log("create invoice page calling");
    // return () => {};
  }, []);

  return (
    <div style={{ maxWidth: "400px" }} className="mt-3">
      <BarcodeReader
        //   delay={300}
          onError={handleError}
          onScan={handleScan}
        //   style={{ width: '100%' }}
        //   onUpdate={(err, result) => {
        //     if (result) setQRData(result.text);
        //     else setQRData("Not Found");
        //   }}
        />
      {/* <BarcodeScanner
        config={{
          intervalBetweenKeyPress: 100,
          scanningEndTimeout: 200,
          debug: true,
          ignoreOnInput: false,
          historyLength: 0,
        }}
      /> */}

      <p>{qrData}</p>
      {/* new one */}
    </div>
  );
};

export default Scanner;
